// AboutUs.styles.js

const AboutUsStyles = {
    heroSection: {
      height: '50vh',
      backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      textAlign: 'center',
      padding: '2rem',
    },
    heroTitle: {
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    heroSubtitle: {
      fontSize: '1.2rem',
    },
    missionSection: {
      padding: '40px 20px',
      backgroundColor: '#f7f7f7',
    },
    missionCard: {
      padding: '2rem',
      textAlign: 'center',
      borderRadius: '8px',
      boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
    },
    visionCard: {
      padding: '2rem',
      textAlign: 'center',
      borderRadius: '8px',
      boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
    },
    sectionTitle: {
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#555',
    },
    servicesSection: {
      padding: '40px 20px',
      backgroundColor: '#ffffff',
    },
    serviceCard: {
      padding: '2rem',
      textAlign: 'center',
      boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
      borderRadius: '8px',
    },
    serviceTitle: {
      fontWeight: 'bold',
      marginBottom: '12px',
    },
    valuesSection: {
      padding: '40px 20px',
      backgroundColor: '#f4f4f9',
      textAlign: 'center',
    },
    valueCard: {
      padding: '2rem',
      textAlign: 'center',
      borderRadius: '8px',
      boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
    },
    valueTitle: {
      fontWeight: 'bold',
      marginBottom: '8px',
    },
    valueText: {
      color: '#555',
    },
  };
  
  export default AboutUsStyles;
  